// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2p_OL","comment":"styles_comment__1VEtp"};